@let update = statusUpdate();
@if (update) {
  <div class="layout-column gap-5">
    @if (update.hasStatusUpdate) {
      <div class="layout-row layout-align-start-center gap-5">
        <span class="font-weight-600">{{ 'Updated by' | translate }}</span>
        <span>{{ update.updatedBy || '-' }}</span>
      </div>
      <div class="layout-row layout-align-start-center gap-5">
        <span class="font-weight-600">{{ 'Updated at' | translate }}</span>
        <span>{{ update | bringozFullDate:'updatedAt' }} {{ update | bringozTime:'updatedAt' }}</span>
      </div>
    } @else {
      <span>{{ 'No status updates' | translate }}</span>
    }
  </div>
} @else {
  <div class="layout-row layout-align-center-center">
    <div class="spinner-border spinner-border-sm" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
}
